module.exports = require("./../../_gen/starling/display/Image");